import { render, staticRenderFns } from "./branch-selector.vue?vue&type=template&id=852ea616&"
import script from "./branch-selector.vue?vue&type=script&lang=js&"
export * from "./branch-selector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports